import { render, staticRenderFns } from "./RoutedChat.vue?vue&type=template&id=41b89bd6&"
import script from "./RoutedChat.vue?vue&type=script&lang=js&"
export * from "./RoutedChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports